<template>
  <div class="sidebar-banner d-flex flex-column flex-gap-1">
    <plan-banner
      class="plan-banner-container"
      :plan-limit-shown="planLimitShown"
      :upgrade-button-shown="upgradeButtonShown"
      :is-onboard-button-shown="!isOnboardBannerShown"
      @onShowOnboardBanner="showOnboardBanner"
    />
    <onboard-banner v-if="isOnboardBannerShown" @onClose="hideOnboardBanner" />
  </div>
</template>

<script>
import PlanBanner from "@/components/global/planBanner/plan-banner.vue";
import OnboardBanner from "@/components/global/onboardBanner/onboard-banner.vue";

const IS_ONBOARD_BANNER_HIDDEN_KEY = "isOnboardBannerHidden";

export default {
  name: "SidebarBanner",

  components: {
    PlanBanner,
    OnboardBanner,
  },

  inject: ["accountProvider"],

  data() {
    return {
      isOnboardBannerShown: false,
      // isOnboardBannerShown: !JSON.parse(
      //   localStorage.getItem(IS_ONBOARD_BANNER_HIDDEN_KEY)
      // ),
    };
  },

  computed: {
    user() {
      return this.$store.state.user || {};
    },

    limit() {
      return this.accountProvider.usage?.essaysUsage?.limit;
    },

    count() {
      return this.accountProvider.usage?.essaysUsage?.count;
    },

    isLimitExceeded() {
      return (this.count / this.limit) * 100 > 75;
    },

    planLimitShown() {
      switch (this.user?.plan) {
        case "basic":
          return true;
        case "lite":
          return this.isLimitExceeded;
        case "pro":
          return this.isLimitExceeded;
        case "premium":
          return false;
        default:
          return true;
      }
    },

    upgradeButtonShown() {
      switch (this.user?.plan) {
        case "basic":
          return true;
        case "lite":
          return true;
        case "pro":
          return this.isLimitExceeded;
        case "premium":
          return false;
        default:
          return true;
      }
    },
  },

  methods: {
    showOnboardBanner() {
      this.isOnboardBannerShown = true;
      localStorage.setItem(IS_ONBOARD_BANNER_HIDDEN_KEY, JSON.stringify(false));
    },
    hideOnboardBanner() {
      this.isOnboardBannerShown = false;
      localStorage.setItem(IS_ONBOARD_BANNER_HIDDEN_KEY, JSON.stringify(true));
    },
  },
};
</script>

<style scoped lang="scss">
.sidebar-banner {
  margin-top: auto;
  padding: 12px;
}

.plan-banner-container {
  padding: 1rem;
  border: 1px solid var(--color-stroke-neutral-default);
  @media (max-height: 769px) {
    padding: 12px;
  }
}
</style>
